module.exports = __webpack_public_path__ + "img/MDI-information-new.fa59a0c7.svg";